import React, { useState } from "react";
import styled from "styled-components/macro";
import PropTypes from "prop-types";
import NavSubLink from "./offcanvas-nav/NavSubLink.styled";
import NavSubLinkAnchor from "./offcanvas-nav/NavSubLinkAnchor.styled";

const Item = styled.li`
  display: block;
  justify-content: space-between;
  position: relative;
  list-style: none;
  font-size: 16px;
  color: ${(props) =>
    props.over ? props.theme.colors.primary : props.theme.colors.colorGrayDark};
`;

const ListItem = ({ name, link, isPublic, inNewTab, handleOpen }) => {
  const [over, setMouseOver] = useState(false);

  const renderLink = () => {
    if (isPublic) {
      return <NavSubLinkAnchor href={link}>{name}</NavSubLinkAnchor>;
    } else if (inNewTab) {
      return (
        <NavSubLinkAnchor href={link} target="_blank" rel="noreferrer">
          {name}
        </NavSubLinkAnchor>
      );
    } else {
      return <NavSubLink to={link}>{name}</NavSubLink>;
    }
  };

  return (
    <Item
      onMouseOver={() => {
        if (window.innerWidth >= 1165) {
          setMouseOver(true);
        }
      }}
      onMouseOut={() => {
        if (window.innerWidth >= 1165) {
          setMouseOver(false);
        }
      }}
      onClick={() => {
        setMouseOver(!over);
        handleOpen != null && handleOpen();
      }}
      over={over}
    >
      {renderLink()}
    </Item>
  );
};

ListItem.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default ListItem;
